import React, { PropTypes } from "react";

import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { SelectInput, TextInput } from "../../../../common/form";
import { FINTECH } from "../../../../../utils/Roles";
import { GM } from "../../enums/businessAccountTypes";
import userHasAccess from "../../../../../utils/userHasAccess";
import { CLIENTS_VALIDATION_RULES } from "../../clientValidationRules";
import { MANUAL } from "../../enums/billingPeriodTypes";
import insuranceStatuses from "../../enums/insuranceStatuses";
import ratePeriodTypes from "../../enums/ratePeriodTypes";

import { MessageBox } from "../../../../common";
import { IMPLEMENTATION } from "../../enums/clientStatusTypes";
import { ELIGIBILITY } from "../../enums/synchronizationOptions";
class ClientInformation extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {
            disabled,
            add,
            clientBillingPeriodType,
            businessAccountType,
            isInactive,
            clientNumberExists,
            clientStatusType,
            hasMembers,
            currentSyncType,
            formSyncType,
            isMemberIdentifierConfigurationDuplicated,
            clientBillingPeriodOptions,
        } = this.props;

        const isClientNumberDisabledForEligibility = !userHasAccess(FINTECH) && ((currentSyncType === ELIGIBILITY.value && !add) || (formSyncType === ELIGIBILITY.value && add));
        const isClientNumberDisabledForStatusAndMembers =
            !userHasAccess(FINTECH) &&
            ((clientStatusType && clientStatusType !== IMPLEMENTATION.value) || hasMembers === true || hasMembers === null) && !add;
        return (
            <div className="ClientSubsection">
                <h3>
                    <FormattedMessage id="clients.form.client.title" />
                </h3>
                <Field
                    id="name"
                    name="name"
                    type="text"
                    component={TextInput}
                    required={true}
                    label={<FormattedMessage id="clients.form.client.name" />}
                    disabled={disabled || isInactive}
                />

                <Field
                    id="fullName"
                    name="fullName"
                    type="text"
                    component={TextInput}
                    required={true}
                    label={<FormattedMessage id="clients.form.client.fullName" />}
                    disabled={disabled || isInactive}
                />

                <Field
                    id="designator"
                    name="designator"
                    type="text"
                    maxLength={CLIENTS_VALIDATION_RULES.designator.maxLength.value}
                    component={TextInput}
                    required={true}
                    label={<FormattedMessage id="clients.form.client.designator" />}
                    normalize={(value) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}
                    disabled={disabled || isInactive}
                />

                <Field
                    id="clientInsuranceStatusType"
                    name="clientInsuranceStatusType"
                    component={SelectInput}
                    disabled={disabled || isInactive}
                    label={<FormattedMessage id="clients.form.client.type" />}
                    options={insuranceStatuses}
                />
                <Field
                    id="coverageWebsite"
                    name="coverageWebsite"
                    type="text"
                    component={TextInput}
                    label={<FormattedMessage id="clients.form.client.coverageWebsite" />}
                    disabled={disabled || isInactive}
                />

                <Field
                    id="clientBillingPeriodType"
                    name="clientBillingPeriodType"
                    component={SelectInput}
                    required={true}
                    disabled={!add || disabled || isInactive}
                    options={clientBillingPeriodOptions}
                    addBlankOption={true}
                    label={<FormattedMessage id="clients.form.client.billingPeriods" />}
                />

                {(clientBillingPeriodType === MANUAL.value && businessAccountType != GM.acronym) && (
                    <Field
                        id="ratePeriodType"
                        name="ratePeriodType"
                        component={SelectInput}
                        disabled={!add || disabled || isInactive}
                        options={ratePeriodTypes}
                        label={<FormattedMessage id="clients.form.client.ratePeriodType" />}
                    />
                )}
                <Field
                    id="clientNumber"
                    name="clientNumber"
                    component={TextInput}
                    disabled={
                        disabled || isClientNumberDisabledForEligibility || isClientNumberDisabledForStatusAndMembers
                    }
                    onChange={clientNumberExists}
                    label={<FormattedMessage id="clients.form.otherInformation.clientNumber" />}
                />
                {businessAccountType == GM.acronym && (isMemberIdentifierConfigurationDuplicated &&
                    ((clientStatusType && clientStatusType !== IMPLEMENTATION.value) || !hasMembers)) && (
                        <MessageBox className="alert-info">
                            <FormattedMessage id="clients.form.additionalConfigurations.clientNumberExists" />
                        </MessageBox>
                    )}
            </div>
        );
    }
}

ClientInformation.propTypes = {
    add: PropTypes.bool,
    clientBillingPeriodType: PropTypes.string,
    businessAccountType: PropTypes.string,
    isInactive: PropTypes.bool,
    disabled: PropTypes.bool,
    clientNumberExists: PropTypes.func,
    clientStatusType: PropTypes.string,
    hasMembers: PropTypes.bool,
    isMemberIdentifierConfigurationDuplicated: PropTypes.bool,
    currentSyncType: PropTypes.string,
    formSyncType: PropTypes.string,
    clientBillingPeriodOptions: PropTypes.array
};

export default ClientInformation;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientInformation.js